const SidebarSkeleton = ({ classes }: { classes: string }) => {
    return (
        <div className="animate-pulse">
            <div className={classes}></div>
        </div>
    );
};

export default SidebarSkeleton;
